import React from "react";

// Help/Support Icon
export const HelpIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 40.824 40.63" {...props}>
    <defs>
      <clipPath id="clip-path-help">
        <rect width="40.824" height="40.63" fill="#d66f67" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip-path-help)">
      <path
        d="M10.065,19.836h-6.3A3.767,3.767,0,0,1,0,16.071V8.955A3.767,3.767,0,0,1,3.762,5.19h6.3A1.024,1.024,0,0,1,11.09,6.212v12.6a1.024,1.024,0,0,1-1.025,1.022m-6.3-12.6a1.724,1.724,0,0,0-1.72,1.72v7.117a1.722,1.722,0,0,0,1.72,1.72H9.043V7.234Z"
        transform="translate(0.002 12.492)"
        fill="#d66f67"
      />
      <path
        d="M16.056,19.836H9.75a1.025,1.025,0,0,1-1.022-1.022V6.212A1.025,1.025,0,0,1,9.75,5.19h6.306a3.767,3.767,0,0,1,3.761,3.765v7.117a3.767,3.767,0,0,1-3.761,3.765m-5.284-2.044h5.284a1.724,1.724,0,0,0,1.72-1.72V8.955a1.722,1.722,0,0,0-1.72-1.72H10.772Z"
        transform="translate(21.007 12.492)"
        fill="#d66f67"
      />
      <path
        d="M2.628,19.725A1.021,1.021,0,0,1,1.606,18.7V14.942a14.942,14.942,0,1,1,29.885,0v3.4a1.02,1.02,0,1,1-2.041,0v-3.4a12.9,12.9,0,0,0-25.8,0V18.7a1.021,1.021,0,0,1-1.022,1.022"
        transform="translate(3.865 0.001)"
        fill="#d66f67"
      />
      <path
        d="M15.526,16.041H7.591a1.022,1.022,0,1,1,0-2.044h7.934a2.927,2.927,0,0,0,2.923-2.923V10a1.022,1.022,0,0,1,2.044,0v1.077a4.973,4.973,0,0,1-4.967,4.967"
        transform="translate(15.81 21.602)"
        fill="#d66f67"
      />
      <path
        d="M8.825,17.591a4.01,4.01,0,1,1,4.01-4.006,4.011,4.011,0,0,1-4.01,4.006m0-5.976a1.967,1.967,0,1,0,1.969,1.969,1.969,1.969,0,0,0-1.969-1.969"
        transform="translate(11.589 23.036)"
        fill="#d66f67"
      />
    </g>
  </svg>
);

// Read Guide Icon
export const ReadGuideIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 44.307 53.318" {...props}>
    <defs>
      <clipPath id="clip-path-guide">
        <rect width="44.307" height="53.318" fill="#609690" />
      </clipPath>
    </defs>
    <g clipPath="url(#clip-path-guide)">
      <path
        d="M35.552,53.318H7.178A6.232,6.232,0,0,1,.724,47.352V16.593a1.044,1.044,0,1,1,2.089,0V47.352a4.15,4.15,0,0,0,4.365,3.877H35.552a4.146,4.146,0,0,0,4.361-3.877V5.97a4.147,4.147,0,0,0-4.361-3.881H7.178A4.151,4.151,0,0,0,2.813,5.97v3.4a1.044,1.044,0,1,1-2.089,0V5.97A6.233,6.233,0,0,1,7.178,0H35.552A6.229,6.229,0,0,1,42,5.97V47.352a6.228,6.228,0,0,1-6.45,5.965"
        transform="translate(2.301 0.001)"
        fill="#609690"
      />
      <path
        d="M26.878,3.887a1.7,1.7,0,0,1,1.842,1.5v30.37a1.744,1.744,0,0,1-1.842,1.5H6.245a1.744,1.744,0,0,1-1.842-1.5V34.286A3.345,3.345,0,0,0,6.88,31.124,3.4,3.4,0,0,0,4.4,27.97V24.093A3.345,3.345,0,0,0,6.88,20.931,3.4,3.4,0,0,0,4.4,17.777V13.9A3.345,3.345,0,0,0,6.88,10.738,3.4,3.4,0,0,0,4.4,7.584V5.391a1.7,1.7,0,0,1,1.842-1.5Zm0-2.089H6.245A3.769,3.769,0,0,0,2.314,5.391V9.485h.861a1.473,1.473,0,0,1,1.617,1.253c0,.71-.7,1.253-1.617,1.253H2.314v7.687h.861a1.473,1.473,0,0,1,1.617,1.253c0,.71-.7,1.253-1.617,1.253H2.314v7.687h.861a1.473,1.473,0,0,1,1.617,1.253c0,.71-.7,1.253-1.617,1.253H2.314v3.384a3.8,3.8,0,0,0,3.931,3.593H26.878a3.8,3.8,0,0,0,3.931-3.593V5.391A3.769,3.769,0,0,0,26.878,1.8"
        transform="translate(7.353 5.714)"
        fill="#609690"
      />
      <path
        d="M6.939,10.66H1.044a1.044,1.044,0,1,1,0-2.089H6.939a1.044,1.044,0,1,1,0,2.089"
        transform="translate(0 27.236)"
        fill="#609690"
      />
      <path
        d="M6.939,8.22H1.044a1.044,1.044,0,1,1,0-2.089H6.939a1.044,1.044,0,1,1,0,2.089"
        transform="translate(0 19.483)"
        fill="#609690"
      />
      <path
        d="M6.939,5.781H1.044a1.044,1.044,0,1,1,0-2.089H6.939a1.044,1.044,0,1,1,0,2.089"
        transform="translate(0 11.733)"
        fill="#609690"
      />
      <path
        d="M19.866,5.334H5A1.044,1.044,0,0,1,5,3.245H19.866a1.044,1.044,0,0,1,0,2.089"
        transform="translate(12.564 10.312)"
        fill="#609690"
      />
      <path
        d="M15.722,6.783H5A1.044,1.044,0,1,1,5,4.694H15.722a1.044,1.044,0,1,1,0,2.089"
        transform="translate(12.564 14.916)"
        fill="#609690"
      />
    </g>
  </svg>
);

// Create Recipe Icon
export const CreateRecipeIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 55 53" {...props}>
    <defs>
      <rect
        id="path-create-recipe"
        x="0"
        y="0"
        width="54.011"
        height="52.778"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g fill="#609690" fillRule="nonzero">
        <g>
          <path d="M39.174,52.8146476 L7.861,52.8146476 C3.52131745,52.8102379 0.00440968974,49.2933301 -8.73634498e-16,44.9536476 L-8.73634498e-16,13.6406476 C0.00440968974,9.30096503 3.52131745,5.78405727 7.861,5.77964758 L28.407,5.77964758 C29.0948003,5.79894582 29.6423524,6.36207664 29.6423524,7.05014758 C29.6423524,7.73821852 29.0948003,8.30134934 28.407,8.32064758 L7.861,8.32064758 C4.92489981,8.32560211 2.54595452,10.7045474 2.541,13.6406476 L2.541,44.9536476 C2.54430657,47.8904317 4.92421585,50.270341 7.861,50.2736476 L39.174,50.2736476 C42.111469,50.2719925 44.4923449,47.8911166 44.494,44.9536476 L44.494,24.7536476 C44.5132982,24.0658473 45.0764291,23.5182952 45.7645,23.5182952 C46.4525709,23.5182952 47.0157018,24.0658473 47.035,24.7536476 L47.035,44.9536476 C47.0289411,49.2926458 43.5129983,52.8085887 39.174,52.8146476" />
          <path d="M45.765,16.5286492 C45.427747,16.5291795 45.1041541,16.3954418 44.8656799,16.1569677 C44.6272058,15.9184935 44.4934681,15.5949005 44.494,15.2576476 L44.494,1.30664758 C44.4810259,0.844242731 44.7203042,0.411300827 45.118736,0.176271783 C45.5171678,-0.0587572611 46.0118322,-0.0587572611 46.410264,0.176271783 C46.8086958,0.411300827 47.0479741,0.844242731 47.035,1.30664758 L47.035,15.2576476 C47.0355319,15.5949005 46.9017942,15.9184935 46.6633201,16.1569677 C46.4248459,16.3954418 46.101253,16.5291795 45.764,16.5286492" />
          <path d="M52.744,9.55264758 L38.793,9.55264758 C38.1051997,9.53334934 37.5576476,8.97021852 37.5576476,8.28214758 C37.5576476,7.59407664 38.1051997,7.03094582 38.793,7.01164758 L52.744,7.01164758 C53.2064048,6.99867346 53.6393468,7.23795176 53.8743758,7.63638359 C54.1094048,8.03481542 54.1094048,8.52947974 53.8743758,8.92791157 C53.6393468,9.3263434 53.2064048,9.5656217 52.744,9.55264758" />
        </g>
      </g>
    </g>
  </svg>
);

// Contribute To Recipe Icon
export const ContributeToRecipeIcon = (
  props: React.SVGProps<SVGSVGElement>
) => (
  <svg viewBox="0 0 47.873 54.742" {...props}>
    <defs>
      <clipPath id="clip-path">
        <rect
          id="Rectangle_1367"
          data-name="Rectangle 1367"
          width="47.873"
          height="54.742"
          fill="#609690"
        />
      </clipPath>
    </defs>
    <g
      id="Contribute_to_existing_recipe_icon"
      data-name="Contribute to existing recipe icon"
      transform="translate(0 0)"
    >
      <g
        id="Group_1786"
        data-name="Group 1786"
        transform="translate(0 0)"
        clipPath="url(#clip-path)"
      >
        <path
          id="Path_2591"
          data-name="Path 2591"
          d="M3.363,36.772A3.368,3.368,0,0,1,0,33.405V7.605A3.365,3.365,0,0,1,3.363,4.239H8.95a.974.974,0,1,1,0,1.948H3.363A1.424,1.424,0,0,0,1.945,7.605v25.8A1.423,1.423,0,0,0,3.363,34.82H44.5a1.418,1.418,0,0,0,1.419-1.415V7.605A1.419,1.419,0,0,0,44.5,6.187h-5.7a.974.974,0,1,1,0-1.948h5.7A3.368,3.368,0,0,1,47.87,7.605v25.8A3.371,3.371,0,0,1,44.5,36.772Z"
          transform="translate(0.003 12.748)"
          fill="#609690"
        />
        <path
          id="Path_2592"
          data-name="Path 2592"
          d="M5.951,19.043a.977.977,0,0,1-.978-.978V12.844a.976.976,0,0,1,.978-.974h6.063a.975.975,0,0,1,.974.974v5.222a.976.976,0,0,1-.974.978ZM6.925,17.2l4.224-.112-.108-3.382-4.116.108Z"
          transform="translate(14.956 35.698)"
          fill="#609690"
        />
        <path
          id="Path_2593"
          data-name="Path 2593"
          d="M.977,12.441a.976.976,0,1,1,0-1.952H46.9a.976.976,0,0,1,0,1.952Z"
          transform="translate(-0.003 31.544)"
          fill="#609690"
        />
        <path
          id="Path_2594"
          data-name="Path 2594"
          d="M4.791,15.125a.976.976,0,0,1,0-1.952H20.123a.976.976,0,0,1,0,1.952Z"
          transform="translate(11.479 39.616)"
          fill="#609690"
        />
        <path
          id="Path_2595"
          data-name="Path 2595"
          d="M33.007,38.54H3.155a1.2,1.2,0,0,1-1.2-1.2V1.2A1.2,1.2,0,0,1,3.155,0H33.007a1.2,1.2,0,0,1,1.2,1.2V37.341a1.2,1.2,0,0,1-1.2,1.2m-28.649-2.4H31.809V2.4H4.357Z"
          transform="translate(5.874 -0.001)"
          fill="#609690"
        />
        <path
          id="Path_2596"
          data-name="Path 2596"
          d="M23.525,4.663H4.461a1.2,1.2,0,0,1,0-2.4H23.525a1.2,1.2,0,1,1,0,2.4"
          transform="translate(9.801 6.793)"
          fill="#609690"
        />
        <path
          id="Path_2597"
          data-name="Path 2597"
          d="M16.567,6.543H5.454a1.2,1.2,0,1,1,0-2.4H16.567a1.2,1.2,0,1,1,0,2.4"
          transform="translate(12.788 12.447)"
          fill="#609690"
        />
      </g>
    </g>
  </svg>
);

// Contribution Tile
export const ContributionTile = ({ icon, ...props }: any) => (
  <div {...props}>
    {React.cloneElement(icon, { width: "100%", height: "100%" })}
  </div>
);
